import React, {Component} from 'react';
import {Page, Card, TextField, FormLayout,Banner, Select, ChoiceList,Stack,Checkbox,Icon,Button, Link, TextContainer} from "@shopify/polaris";
import {requests} from "../../services/request";
import {isUndefined} from "util";
import {notify} from "../../services/notify";




const ShippingPolicyServicetype=[
  {label:'Flat',value:'Flat'},
  {label:'Calculated',value:'Calculated'},
  {label:'Calculated Domestic Flat International',value:'CalculatedDomesticFlatInternational'},
  {label:'Flat Domestic Calculated International',value:'FlatDomesticCalculatedInternational'},
  // {label:'Freight',value:'FreightFlat'},
];




const countriestoInclude=[
  {value : 'Worldwide', label :'Worldwide'},
  {value : 'CA', label :'Canada'},
  {value : 'Americas', label :'Americas'},
  {value:'Europe', label:'Europe'},
  {value: 'Asia',label :'Asia'},
  {value: 'AU',label :'Australia'},
  {value: 'UK',label :'United Kingdom'},
  {value: 'MX',label :'Mexico'},
  {value: 'DE',label :'Germany'},
  {value: 'JP',label :'Japan'},
  {value: 'BR',label :'Brazil'},
  {value: 'FR',label :'France'},
  {value: 'CN',label :'China'},
  {value: 'RU',label :'Russian Federation'},
  {value : 'Africa', label :'Africa'},
  {value : 'Caribbean', label :'Caribbean'},
  {value : 'EuropeanUnion', label:' European Union'},
  {value : 'CustomCode', label :'Reserved for internal or future use'},
  {value:'LatinAmerica',label:' Latin America'},
  {value : 'MiddleEast',label:'Middle East'},
  {value : 'None', label :'(description not yet available)'},
  {value : 'NorthAmerica', label :' North America'},
  {value : 'Oceania', label:' Oceania (Pacific region other than Asia)'},
  {value : 'SouthAmerica', label :'South America'},
  {value : 'WillNotShip ', label :' Seller will not ship the item.'},


];

let tempObjShippingserviceDomestic={service:'',charges:'',codfee:'',additional_charges:'',free_shipping:false};
let tempObjShippingserviceInternational= {service:'',charges:'',codfee:'',additional_charges:'',ship_to:[]};


class AccountSettings extends Component {

  constructor(props){
    super(props);
    this.state={
      loader:false,
      site_id:'US',
      data_saved_successfully:{
        payment_policy:false,
        shipping_policy:false,
        return_policy:false,
        config_data:false,
      },
      errors:{
        business_policies:{
          payment_policy:{
            existing_id:false,
            name:false,
            selected:false,
            paypal_email:false,
            motors:{
              paypal:false,
              deposit_details:{
                days_to_full_payment:false,
                deposit_amount:false,
                hours_to_deposit:false
              }
            },
          },
          shipping_policy:{
            existing_id:false,
            name:false,
            domestic: {
              service_not_selected: false,
              null_services: [],
              handling_time:false,
              buyer_responsible_for_pickup:false,
              shipping_surcharge: false
            },
            international:{
              service_not_selected: false,
              null_services: [],
              buyer_responsible_for_pickup:false,
              shipping_surcharge: false
            },
            exclude_locations:false
          },
          return_policy:{
            existing_id:false,
            name:false,
            domestic:{
              return_within:false,
              return_paid_by:false,
            }
          }
        },
        config_data:{
          item_location:{
            country:false,
            zipcode:false,
            city_state:false
          },

        },

        app_setting:{
          product_sync:false,
          order_sync:false
        }
      },

      dropdown: {
        shipping_policy:{
          selected_id:'',
          show_dropdown:false,
          options:[]
        },

        payment_policy:
          {
            selected_id:'',
            show_dropdown:false,
            options:[]
          },
        return_policy:{
          selected_id:'',
          show_dropdown:false,
          options:[]
        },
      },

      create_new_profile:{
        shipping_policy:false,
        payment_policy:false,
        return_policy:false,
      },

      product_details:{
        template_name:''
      },

      app_setting:{

        order_sync:'yes'
      },

      selling_details:{
        reason_end_listing:'Incorrect',
        vrm:'',
        vin:'',
        dimension:{
          length:'',
          width:'',
          height:'',
          unit:''
        },
        business_seller:'',
        restricted_to_business:'',
        vat_percentage:'',
        /* format:'fixed_price',*/
        country:'US',
        state:'',
        /* listing_duration:'GTC',*/
        use_seller_profile:false,
        tax_percentage:'',
        shipping_include:false,
        variation_image_setting:[],
        item_location:{
          country:'',
          zipcode:'',
          city_state:'',
          currency:''
        },
        synced_by:false,
        order_import_setting: {
          order_create: {
            month: new Date().getMonth(),
            year: new Date().getFullYear(),
            selected: {
              start: new Date(),
              end: new Date(),
            },
          },
          modify_order:{
            month: new Date().getMonth(),
            year: new Date().getFullYear(),
            selected: {
              start: new Date(),
              end: new Date(),
            },

          },
          number_of_days:7
        },
        exclude_locations:false,
        excluded_shipping_location:[],
        webhook_setting:'no'

      },
      shipping_policy:{
        name:'',
        service_type:'Flat',
        /*free_shipping:true,*/
        global_shipping:false,
        domestic:{
          /*additional_charges:0,*/
          handling_time:"1",
          handling_cost:0,
          shipping_surcharge:0,
          buyer_responsible_for_pickup:'',
          buyer_responsible_for_shipping:false,
          PromotionalShippingDiscount:'',
        },
        international:{
          /* additional_charges:0,*/
          buyer_responsible_for_pickup:'',
          buyer_responsible_for_shipping:false,
          shipping_surcharge:0,
          handling_cost:0,
          global_ship_to:[],
          InternationalPromotionalShippingDiscount:''
        },
        shipping_service_domestic:[
          {service:'',charges:'',codfee:'',additional_charges:0,free_shipping:true}
        ],
        shipping_service_international:[
          {service:'',charges:'',codfee:'',additional_charges:0,ship_to:[]}
        ],
        exclude_locations:false,
        excluded_shipping_location:[],
      },
      payment_policy:{
        immediate_pay:false,
        name:'',
        payment_methods:[],
        checkout_instruction:'',
        paypal_email:'',
        deposit_details:{
          days_to_full_payment:'',
          deposit_amount:'',
          hours_to_deposit:''
        }
      },
      return_policy:{
        name:'',
        return_accepted:['domestic'],
        returns_accepted_option:true,
        return_accepted_options:[
          {label:'Domestic returns accepted',value:'domestic'},
          /* {label:'International returns accepted',value:'international'},*/
        ],
        return_option:'',
        domestic:{
          return_paid_by:'',
          return_within:'',
          replacement_exchange_available:false
        },
        international:{
          return_paid_by:'',
          return_within:'',
          replacement_exchange_available:false
        },
        return_description:''
      },

      options_recieved:{
        shipping_service_options:{
          domestic:[],
          international:[]
        },
        return_policy:[],
        country:[],
        states:[],
        currency:[],
        excluded_shipping_locations:[],
        payment_methods:[],
        shipping_service: {
          domestic: {
            Flat: [],
            Calculated: [],
            FreightFlat: [],
          },
          international :{
            Flat:[],
            Calculated:[],
            FreightFlat:[],
          }
        },
        handling_time:[],
        selected_domestic_service:'0'
      }

    };

    this.getBusinessPolicy();
    this.getShopdetails();
    this.isSetDisplay();
    this.getSideID();

  }



//-----------------------------------Extract Data From API Start------------------------------------//

  extractDispatchTimeMaxDetails(data){
    let temparr=[];
    Object.keys(data).map(key=>{
      temparr.push({
        label:data[key]['Description'],value:data[key]['DispatchTimeMax'].toString()
      })
    });
    this.state.options_recieved.handling_time=temparr;
    this.setState(this.state);
  }

  extractPaymentMethods(data)
  {
    let temparr=[];
    Object.keys(data).map(key=>{
      temparr.push(
        {label:data[key],value:data[key]}
      );
    });
    this.state.options_recieved.payment_methods=temparr;
    this.setState(this.state);
  }

  extractExcludedLocations(data){
    let temparr=[];
    Object.keys(data).map(key=>{
      temparr.push(
        {label:data[key]['Description'],value:data[key]['Location']}
      )
    });
    this.state.options_recieved.excluded_shipping_locations=temparr;
    this.setState(this.state);
  }

  extractReturnPolicyServices(data){
    let preparedObj={};
    let tempObj=Object.assign({},data);
    Object.keys(tempObj).map(key=>{
      if(typeof tempObj[key]==='object') {
        let temparr = [];
        Object.keys(tempObj[key]).map(Obj => {
          temparr.push(
            {label: tempObj[key][Obj]['Description'], value: tempObj[key][Obj][key + 'Option']}
          );
        });
        preparedObj[key] = temparr;
      }
    });
    this.state.options_recieved['return_policy']=preparedObj;
    this.setState(this.state);

  }

  extractCountryDetails(data) {
    let temparr=[];
    Object.keys(data).map(key=>{
      temparr.push(
        {label:data[key]['Description'],value:data[key]['Country']}
      );
    });
    this.state.options_recieved.country=temparr;
    this.setState(this.state);
  }

  extractShippingDetails(data){
    // console.log(data);

    let shipping_service= {
      domestic: {
        Flat: [],
        Calculated: [],
        FreightFlat: [],
      },
      international :{
        Flat:[],
        Calculated:[],
        FreightFlat:[],
      }
    };

    let analysis_arr=[];

    let levelTwoObject_categorywise={
      domestic:{
        Flat:{},
        Calculated:{}
      },
      international:{
        Flat:{},
        Calculated:{}
      }
    };
    Object.keys(data).map(key=>{
        let options_analysis={};
        options_analysis['category']=data[key]['ShippingCategory'];
        options_analysis['label']=data[key]['Description'];
        options_analysis['value']=data[key]['ShippingService'];
        options_analysis['area']=data[key]['InternationalService']?'international':'domestic';
        let serviceTypePresent=[];
        if(!isUndefined(data[key]['ServiceType'])) {
          if (Array.isArray(data[key]['ServiceType'])) {
            serviceTypePresent = data[key]['ServiceType'].slice(0);
          } else {
            serviceTypePresent = Object.values(data[key]['ServiceType']);
          }
        }
        else{
          serviceTypePresent = ["Flat","Calculated"];
        }

        if(serviceTypePresent.indexOf("Flat")>-1 && serviceTypePresent.indexOf("Calculated")>-1)
        {
          options_analysis['service_type']='both';
        }
        else if(serviceTypePresent.indexOf('Flat')>-1){
          options_analysis['service_type']='Flat';
        }
        else if(serviceTypePresent.indexOf('Calculated')>-1){
          options_analysis['service_type']='Calculated';
        }
        else if(serviceTypePresent.indexOf('Freight')>-1){
          options_analysis['service_type']='FreightFlat';
        }
        analysis_arr.push(options_analysis);
      }
    );
    analysis_arr.forEach((value,index)=> {

      if(value.service_type==='both'){
        levelTwoObject_categorywise[value.area].Flat[value.category]=[];
        levelTwoObject_categorywise[value.area].Calculated[value.category]=[];
      }
      else {
        if(isUndefined(levelTwoObject_categorywise[value.area][value.service_type])){
          levelTwoObject_categorywise[value.area][value.service_type]={};
          levelTwoObject_categorywise[value.area][value.service_type][value.category]=[];
        }
        else{
          levelTwoObject_categorywise[value.area][value.service_type][value.category]=[];
        }
      }
    });

    analysis_arr.forEach((value,index)=>{
      if(value.service_type==='both') {
        levelTwoObject_categorywise[value.area].Flat[value.category].push(
          {label:value.label,value:value.value}
        );
        levelTwoObject_categorywise[value.area].Calculated[value.category].push(
          {label:value.label,value:value.value}
        );
      }
      else{
        levelTwoObject_categorywise[value.area][value.service_type][value.category].push(
          {label:value.label,value:value.value}
        );
      }
    });

    Object.keys(levelTwoObject_categorywise).map(region=>{
      Object.keys(levelTwoObject_categorywise[region]).map(servicetype=>{
        Object.keys(levelTwoObject_categorywise[region][servicetype]).map(heading=>{
          shipping_service[region][servicetype].push({
            title:heading,options:levelTwoObject_categorywise[region][servicetype][heading]
          });
        });

      });
    });
    this.state.options_recieved.shipping_service=shipping_service;
    this.state.options_recieved.shipping_service_options.domestic=shipping_service.domestic.Flat;
    this.state.options_recieved.shipping_service_options.international=shipping_service.international.Flat;
    this.setState(this.state);
  }
//-----------------------------------Extract Data From API End------------------------------------//

// -----------------------------------Handle Error Functions Start------------------------------------//

  validateAppsettings(data){
    let errors = 0;
    Object.keys(data).map(key=>{
      switch(key){
        case 'order_sync':
          if(data[key] === ''){
            this.state.errors.app_setting.order_sync = true;
            errors += 1;
          }else{
            this.state.errors.app_setting.order_sync = false;
          }
          break;
        case 'product_sync':
          if(data[key] === ''){
            this.state.errors.app_setting.product_sync = true;
            errors += 1;
          }else{
            this.state.errors.app_setting.product_sync = false;
          }
          break;
      }});
    this.setState(this.state);
    if(errors>0) {
      return false;
    }
    else{
      return true;
    }
  }

  policyValidator(data)
  {

    let errors=0;
    Object.keys(data).map(key=>{

      switch(key){
        case 'payment_policy':
          if(!this.state.data_saved_successfully.payment_policy) {
            if (!isUndefined(data[key]['existing_id']) && this.state.dropdown.payment_policy.show_dropdown) {
              if (data[key]['existing_id'] === '') {
                this.state.errors.business_policies.payment_policy.existing_id = true;
                errors += 1;
              } else {
                this.state.errors.business_policies.payment_policy.existing_id = false;
              }
            } else {
              if (!isUndefined(data[key]['profile_data'])) {
                if (data[key]['profile_data'].name === '') {
                  this.state.errors.business_policies.payment_policy.name = true;
                  errors += 1;
                }
                else {
                  this.state.errors.business_policies.payment_policy.name = false;
                }

                if (this.state.site_id === 'MOTORS') {
                  if (data[key]['profile_data'].payment_methods.indexOf('PayPal') === -1) {
                    this.state.errors.business_policies.payment_policy.motors.paypal = true;
                    errors += 1;
                  } else {
                    this.state.errors.business_policies.payment_policy.motors.paypal = false;
                  }
                  if (data[key]['profile_data'].deposit_details.hours_to_deposit === '') {
                    this.state.errors.business_policies.payment_policy.motors.deposit_details.hours_to_deposit = true;
                    errors += 1;
                  } else {
                    this.state.errors.business_policies.payment_policy.motors.deposit_details.hours_to_deposit = false;
                  }
                  if (data[key]['profile_data'].deposit_details.deposit_amount === '') {
                    errors += 1;
                    this.state.errors.business_policies.payment_policy.motors.deposit_details.deposit_amount = true;
                  } else {
                    this.state.errors.business_policies.payment_policy.motors.deposit_details.deposit_amount = false;
                  }
                  if (data[key]['profile_data'].deposit_details.days_to_full_payment === '') {
                    errors += 1;
                    this.state.errors.business_policies.payment_policy.motors.deposit_details.days_to_full_payment = true;
                  } else {
                    this.state.errors.business_policies.payment_policy.motors.deposit_details.days_to_full_payment = false;
                  }
                }

                if (data[key]['profile_data'].payment_methods.length === 0) {
                  this.state.errors.business_policies.payment_policy.selected = true;
                  errors += 1;
                }
                else {
                  this.state.errors.business_policies.payment_policy.selected = false;
                  if (data[key]['profile_data'].payment_methods.indexOf('PayPal') > -1) {

                    if (data[key]['profile_data'].paypal_email === '' && !(RegExp(/^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/).test(data[key]['profile_data'].paypal_email))) {
                      this.state.errors.business_policies.payment_policy.paypal_email = true;
                      errors += 1;
                    }
                    else {
                      this.state.errors.business_policies.payment_policy.paypal_email = false;
                    }
                  }
                }

              }
            }
          }
          break;
        case 'shipping_policy' :
          if(!this.state.data_saved_successfully.shipping_policy) {
            if (!isUndefined(data[key]['existing_id']) && this.state.dropdown.shipping_policy.show_dropdown) {
              if (data[key]['existing_id'] === '') {
                this.state.errors.business_policies.shipping_policy.existing_id = true;
                errors += 1;
              } else {
                this.state.errors.business_policies.shipping_policy.existing_id = false;
              }
            } else {
              if (!isUndefined(data[key]['profile_data'])) {
                if (data[key]['profile_data'].name === '') {
                  this.state.errors.business_policies.shipping_policy.name = true;
                  errors += 1;
                }
                else {
                  this.state.errors.business_policies.shipping_policy.name = false;
                }

                if (data[key]['profile_data'].domestic.handling_time === '') {
                  this.state.errors.business_policies.shipping_policy.domestic.handling_time = true;
                  errors += 1;
                }
                else {
                  this.state.errors.business_policies.shipping_policy.domestic.handling_time = false;
                }
                if (this.state.site_id === 'MOTORS') {
                  if (data[key]['profile_data'].domestic.buyer_responsible_for_pickup === '') {
                    this.state.errors.business_policies.shipping_policy.domestic.buyer_responsible_for_pickup = true;
                    errors += 1;
                  }
                  else {
                    this.state.errors.business_policies.shipping_policy.domestic.buyer_responsible_for_pickup = false;
                  }
                  if (data[key]['profile_data'].domestic.shipping_surcharge === '') {
                    this.state.errors.business_policies.shipping_policy.domestic.shipping_surcharge = true;
                    errors += 1;
                  }
                  else {
                    this.state.errors.business_policies.shipping_policy.domestic.shipping_surcharge = false;
                  }
                }
                this.state.errors.business_policies.shipping_policy.domestic.null_services = [];
                data[key]['profile_data'].shipping_service_domestic.forEach((value, index) => {

                  if (value.service === '') {
                    this.state.errors.business_policies.shipping_policy.domestic.null_services.push(index + 1);
                  }
                });
                if (this.state.errors.business_policies.shipping_policy.domestic.null_services.length !== 0) {
                  this.state.errors.business_policies.shipping_policy.domestic.service_not_selected = true;
                  errors += 1;
                }
                else {
                  this.state.errors.business_policies.shipping_policy.domestic.service_not_selected = false;
                }

                // if (data[key]['profile_data'].global_shipping) {

                if (this.state.site_id === 'MOTORS') {
                  if (data[key]['profile_data'].international.buyer_responsible_for_pickup === '') {
                    this.state.errors.business_policies.shipping_policy.international.buyer_responsible_for_pickup = true;
                    errors += 1;
                  }
                  else {
                    this.state.errors.business_policies.shipping_policy.international.buyer_responsible_for_pickup = false;
                  }
                  if (data[key]['profile_data'].international.shipping_surcharge === '') {
                    this.state.errors.business_policies.shipping_policy.international.shipping_surcharge = true;
                    errors += 1;
                  }
                  else {
                    this.state.errors.business_policies.shipping_policy.international.shipping_surcharge = false;
                  }
                }

                //     this.state.errors.business_policies.shipping_policy.international.null_services = [];
                //     data[key]['profile_data'].shipping_service_international.forEach((value, index) => {
                //         if (value.service === '') {
                //             this.state.errors.business_policies.shipping_policy.international.null_services.push(index + 1);
                //         }
                //     });
                //     if (this.state.errors.business_policies.shipping_policy.international.null_services.length !== 0) {
                //         this.state.errors.business_policies.shipping_policy.international.service_not_selected = true;
                //         errors += 1;
                //     }
                //     else {
                //         this.state.errors.business_policies.shipping_policy.international.service_not_selected = false;
                //     }
                // }
                else {
                  this.state.errors.business_policies.shipping_policy.international.service_not_selected = false;
                }

                if (data[key]['profile_data'].exclude_locations) {
                  if (data[key]['profile_data'].excluded_shipping_location.length === 0) {
                    this.state.errors.business_policies.shipping_policy.exclude_locations = true;
                    errors += 1;
                  }
                  else {
                    this.state.errors.business_policies.shipping_policy.exclude_locations = false;
                  }
                } else {
                  this.state.errors.business_policies.shipping_policy.exclude_locations = false;
                }
              }
            }
          }
          break;

        case 'return_policy':
          if(!this.state.data_saved_successfully.return_policy) {
            if (this.state.site_id !== 'MOTORS') {
              if (!isUndefined(data[key]['existing_id']) && this.state.dropdown.return_policy.show_dropdown) {
                if (data[key]['existing_id'] === '') {
                  this.state.errors.business_policies.return_policy.existing_id = true;
                  errors += 1;
                } else {
                  this.state.errors.business_policies.return_policy.existing_id = false;
                }
              } else {
                if (!isUndefined(data[key]['profile_data'])) {
                  if (data[key]['profile_data'].name === '') {
                    this.state.errors.business_policies.return_policy.name = true;
                    errors += 1;
                  }
                  else {
                    this.state.errors.business_policies.return_policy.name = false;
                  }
                  if(data[key]['profile_data'].returns_accepted_option) {
                    if (data[key]['profile_data'].domestic.return_paid_by === '') {
                      this.state.errors.business_policies.return_policy.domestic.return_paid_by = true;
                      errors += 1;
                    }
                    else {
                      this.state.errors.business_policies.return_policy.domestic.return_paid_by = false;
                    }
                    if (data[key]['profile_data'].domestic.return_within === '') {
                      this.state.errors.business_policies.return_policy.domestic.return_within = true;
                      errors += 1;
                    }
                    else {
                      this.state.errors.business_policies.return_policy.domestic.return_within = false;
                    }
                  }
                }
              }
            }
          }
          break;
      }
    });
    this.setState(this.state);
    if(errors>0) {
      return false;
    }
    else{
      return true;
    }
  }

  importBusinessPolicies(){
    requests.getRequest('ebayV1/import/businessPolicies').then(data=>{
      if(data.success){
        this.getShopdetails();
        notify.success(data.message);
        this.getBusinessPolicy();
      }
      else{
        notify.error(data.message);
      }
      this.setState({loader:false})
    });
   
  }

  sellingDetailsValidator(data)
  {
    let errors=0;
    // if(data.item_location.city_state==='')
    // {
    //     this.state.errors.config_data.item_location.city_state=true;
    //     errors+=1;
    // }
    // else{
    //     this.state.errors.config_data.item_location.city_state=false;
    // }
    if(data.item_location.zipcode==='')
    {
      this.state.errors.config_data.item_location.zipcode=true;
      errors+=1;
    }
    else{
      this.state.errors.config_data.item_location.zipcode=false;
    }
    // if (this.state.site_id === 'MOTORS') {
    // if (data.item_location.country === '') {
    //     this.state.errors.config_data.item_location.country = true;
    //     errors += 1;
    // }
    // else {
    //     this.state.errors.config_data.item_location.country = false;
    // }
    // }
    this.setState(this.state);
    if(errors>0) {
      return false;
    }
    else{
      return true;
    }
  }
  refetchBusinessPolicies(){
    this.setState({loader:true})
    this.importBusinessPolicies(this)
    
   
  }

//-----------------------------------Handle Error Functions End------------------------------------//


//-----------------------------------Render Functions------------------------------------//
  render() {
    return (
      <Card
      //  title={"Business Policy"}
       sectioned actions={[{content:!isUndefined(this.props.showSave) && this.props.showSave?'Save':'',onAction:this.saveAllprofiles.bind(this)},{content:<Button loading={this.state.loader} primary onClick={this.refetchBusinessPolicies.bind(this)}>Refetch business policy</Button>}]} >
        <Card.Section>
          <Banner status={"info"}>
            Policies you create or choose below will be set as <b>default profile</b> for products but you can change your default settings from <b>Configuration</b> section of the app.
          </Banner>
          <Banner status={"info"}>
            If your business policies on eBay are not visible to you in the dropdown below, Kindly click <span onClick={this.importBusinessPolicies.bind(this)} style={{cursor:'pointer',color:'blue'}}>here</span> to refetch them.
          </Banner>
        {/* {this.props.domain.length > 0 && this.props.domain[0].hasOwnProperty('domainName') && <Banner status="info">You can create business policy directly on eBay seller panel <Link url={`https://www.bizpolicy.ebay${this.props.domain[0]['domainName']}/businesspolicy/manage`} external={true}>Click Here </Link></Banner>} */}
        </Card.Section>
        <Card.Section>
          <FormLayout>
            {!this.state.data_saved_successfully.payment_policy &&
            <Card title={"Payment policy"} 
            // actions=
            // {[{
            //   content:
            //     this.state.dropdown.payment_policy.show_dropdown ? 'Create new' : 'Choose from existing',
            //   onAction: this.enableForm.bind(this, 'payment_policy')
            // }]}
            >
              {
                this.state.dropdown.payment_policy.show_dropdown &&
                <Card.Section>
                  <Select
                    key={'dropdown_payment_details'}
                    options={this.state.dropdown.payment_policy.options}
                    placeholder={"Choose.."}
                    label={'Choose from existing'}
                    error={this.state.errors.business_policies.payment_policy.existing_id ? '*required field' : ''}
                    value={this.state.dropdown.payment_policy.selected_id}
                    onChange={this.dropdownChange.bind(this, 'payment_policy', 'selected_id')}/>
                </Card.Section>
              }
              {!this.state.dropdown.payment_policy.show_dropdown &&
              <Card.Section>
                <TextContainer>
                  {this.props.domain.length > 0 && this.props.domain[0].hasOwnProperty('domainName') && <Banner status="info">You have to create payment policy directly on eBay seller panel <Link url={`https://www.bizpolicy.ebay${this.props.domain[0]['domainName']}/businesspolicy/manage`} external={true}>Click Here </Link></Banner>}
                </TextContainer>
                {
                  // this.renderPaymentOption()
                }
              </Card.Section>
              }
              {!this.state.dropdown.payment_policy.show_dropdown && this.state.site_id === 'MOTORS' &&
              <Card.Section title={'Deposit details'}>
                <FormLayout>
                  <FormLayout.Group>
                    <TextField
                      label="Days to full payment"
                      key={'Days to full payment'}
                      type={'number'}
                      error={this.state.errors.business_policies.payment_policy.motors.deposit_details.days_to_full_payment?' ':''}
                      helpText={'*required'}
                      value={this.state.payment_policy.deposit_details.days_to_full_payment}
                      onChange={this.feildsChangePaymentLevelTwo.bind(this,'deposit_details','days_to_full_payment')}
                    />
                    <TextField
                      label="Deposit Amount"
                      key={'depositAmount'}
                      type={'number'}
                      error={this.state.errors.business_policies.payment_policy.motors.deposit_details.deposit_amount?' ':''}
                      helpText={'*required'}
                      value={this.state.payment_policy.deposit_details.deposit_amount}
                      onChange={this.feildsChangePaymentLevelTwo.bind(this,'deposit_details','deposit_amount')}
                    />
                    <TextField
                      label="Hour's to deposit"
                      key={'HourTodeposit'}
                      type={'number'}
                      error={this.state.errors.business_policies.payment_policy.motors.deposit_details.hours_to_deposit?' ':''}
                      helpText={'*required'}
                      value={this.state.payment_policy.deposit_details.hours_to_deposit}
                      onChange={this.feildsChangePaymentLevelTwo.bind(this,'deposit_details','hours_to_deposit')}
                    />
                  </FormLayout.Group>
                </FormLayout>
              </Card.Section>
              }
            </Card>
            }
            {this.state.data_saved_successfully.payment_policy &&
            <Card>
              <Card.Section>
                <Banner status={"success"}>
                  Payment policy saved successfully
                </Banner>
              </Card.Section>
            </Card>
            }
            {!this.state.data_saved_successfully.shipping_policy &&
            <Card title={"Shipping policy"} 
            // actions={[{
            //   content:
            //     this.state.dropdown.shipping_policy.show_dropdown ? 'Create new' : 'Choose from existing',
            //   onAction: this.enableForm.bind(this, 'shipping_policy')
            // }]}
            >
              {
                this.state.dropdown.shipping_policy.show_dropdown &&
                <Card.Section>
                  <Select
                    key={'dropdown_shipping_policy'}
                    options={this.state.dropdown.shipping_policy.options}
                    label={'Choose from existing'}
                    error={this.state.errors.business_policies.shipping_policy.existing_id ? '*required field' : ''}
                    placeholder={"Choose.."}
                    value={this.state.dropdown.shipping_policy.selected_id}
                    onChange={this.dropdownChange.bind(this, 'shipping_policy', 'selected_id')}/>
                </Card.Section>
              }
              {!this.state.dropdown.shipping_policy.show_dropdown &&
                <Card.Section>
                  <TextContainer>
                    {this.props.domain.length > 0 && this.props.domain[0].hasOwnProperty('domainName') && <Banner status="info">You have to create shipping policy directly on eBay seller panel <Link url={`https://www.bizpolicy.ebay${this.props.domain[0]['domainName']}/businesspolicy/manage`} external={true}>Click Here </Link></Banner>}
                  </TextContainer>
                </Card.Section>
              }
              {/* {!this.state.dropdown.shipping_policy.show_dropdown &&
              <Card.Section>
                <TextField
                  label="Shipping Profile Name"
                  key={'Shipping Profile Name'}
                  type="text"
                  error={this.state.errors.business_policies.shipping_policy.name ? ' ' : ''}
                  helpText={'*required'}
                  value={this.state.shipping_policy.name}
                  onChange={this.nameFeildChange.bind(this, 'shipping_policy', 'name')}
                />
                <br/>
                {
                  this.renderShippingPolicy()
                }
              </Card.Section>
              } */}
              {/* {
                !this.state.dropdown.shipping_policy.show_dropdown &&
                <Card.Section title={'Excluded Shipping Location'}>
                  <Stack key={'Excluded Shipping Location'} distribution={"fillEvenly"}
                         vertical={true}>
                    <Checkbox
                      key={'chooseExcluded Shipping Location'}
                      checked={this.state.shipping_policy.exclude_locations}
                      label="Create Exclusion List"
                      error={this.state.errors.business_policies.shipping_policy.exclude_locations ? '*atleast one excluded location is needed' : ''}
                      onChange={this.feildsChange.bind(this, 'shipping_policy', 'exclude_locations')}
                    />
                    {this.state.shipping_policy.exclude_locations &&
                    <div style={{maxHeight: 100, overflowY: 'scroll'}}>
                      <ChoiceList
                        key={'Exclusion Location'}
                        title={'Exclude Location'}
                        allowMultiple

                        choices={this.state.options_recieved.excluded_shipping_locations}
                        selected={this.state.shipping_policy.excluded_shipping_location}
                        onChange={this.feildsChange.bind(this, 'shipping_policy', 'excluded_shipping_location')}
                      />
                    </div>
                    }
                  </Stack>
                </Card.Section>
              } */}
            </Card>
            }
            {this.state.data_saved_successfully.shipping_policy &&
            <Card>
              <Card.Section>
                <Banner status={"success"}>
                  Shipping policy saved successfully
                </Banner>
              </Card.Section>
            </Card>
            }
            {/*{!this.state.data_saved_successfully.return_policy && this.state.site_id!=='MOTORS' &&*/}
            {!this.state.data_saved_successfully.return_policy &&
            <Card title={"Return policy"} 
            // actions={[{
            //   content:
            //     this.state.dropdown.return_policy.show_dropdown ? 'Create new' : 'Choose from existing',
            //   onAction: this.enableForm.bind(this, 'return_policy')
            // }]}
            >
              {
                this.state.dropdown.return_policy.show_dropdown &&
                <Card.Section>
                  <Select
                    key={'dropdown_return_policy_details'}
                    options={this.state.dropdown.return_policy.options}
                    placeholder={"Choose.."}
                    error={this.state.errors.business_policies.return_policy.existing_id ? ' ' : ''}
                    label={'Choose from existing'}
                    value={this.state.dropdown.return_policy.selected_id}
                    onChange={this.dropdownChange.bind(this, 'return_policy', 'selected_id')}/>
                </Card.Section>
              }
              {!this.state.dropdown.return_policy.show_dropdown &&
                <Card.Section>
                  <TextContainer>
                    {this.props.domain.length > 0 && this.props.domain[0].hasOwnProperty('domainName') && <Banner status="info">You have to create return policy directly on eBay seller panel <Link url={`https://www.bizpolicy.ebay${this.props.domain[0]['domainName']}/businesspolicy/manage`} external={true}>Click Here </Link></Banner>}
                  </TextContainer>
                </Card.Section>
              }
              {/* {!this.state.dropdown.return_policy.show_dropdown &&
              <Card.Section>
                <Stack spacing={"loose"} vertical={true}>
                  <TextField
                    label="Return Profile Name"
                    key={'Return Profile Name'}
                    type="text"
                    error={this.state.errors.business_policies.return_policy.name ? ' ' : ''}
                    helpText={'*required'}
                    value={this.state.return_policy.name}
                    onChange={this.nameFeildChange.bind(this, 'return_policy', 'name')}
                  />
                  <Checkbox
                    key={'reTurnAccepted'}
                    checked={this.state.return_policy.returns_accepted_option}
                    label="Returns accepted"
                    onChange={this.feildsChange.bind(this, 'return_policy', 'returns_accepted_option')}
                  />
                  {
                    this.state.return_policy.returns_accepted_option &&  !isUndefined(this.state.options_recieved.return_policy.Refund) && this.state.options_recieved.return_policy.Refund.length>0 &&
                    <Select
                      key={'selectReturnoption'}
                      options={!isUndefined(this.state.options_recieved.return_policy) && !isUndefined(this.state.options_recieved.return_policy.Refund) ? this.state.options_recieved.return_policy.Refund : []}
                      label={'Refund Option'}
                      placeholder={'Please select...'}
                      value={this.state.return_policy.return_option}
                      onChange={this.feildsChange.bind(this, 'return_policy', 'return_option')}/>
                  }
                  {
                    this.state.return_policy.returns_accepted_option &&
                    this.renderReturnPolicy()
                  }
                  {
                    this.returnDescriptionReturn()
                  }
                </Stack>
              </Card.Section>
              } */}
            </Card>
            }
            {/*{this.state.data_saved_successfully.return_policy && this.state.site_id!=='MOTORS' &&*/}
            {this.state.data_saved_successfully.return_policy  &&
            <Card>
              <Card.Section>
                <Banner status={"success"}>
                  Return policy saved successfully
                </Banner>
              </Card.Section>
            </Card>
            }
            {!this.state.data_saved_successfully.config_data &&
            <Card title={"Selling details"}>
              {
                this.renderSellingdetails()
              }
            </Card>
            }
            {this.state.data_saved_successfully.config_data &&
            <Card>
              <Card.Section>
                <Banner status={"success"}>
                  Configuration data saved successfully
                </Banner>
              </Card.Section>
            </Card>
            }
          </FormLayout>
        </Card.Section>
      </Card>

    );
  }

  renderShippingPolicy(){

    let temparr=[];

    temparr.push(
      <Stack vertical={true} key={'Shipping PolicyCard'}>
        <Stack vertical={false}>
          <Stack.Item fill>
            <Select
              key={'selectShippingpolicytype'}
              options={ShippingPolicyServicetype}
              label={'Service Type'}
              value={this.state.shipping_policy.service_type}
              onChange={this.feildsChange.bind(this,'shipping_policy','service_type')}/>
          </Stack.Item>
          {/*<div style={{marginTop:"3rem"}}>*/}
          {/*<Checkbox*/}
          {/*checked={this.state.shipping_policy.free_shipping}*/}
          {/*label="Free Shipping"*/}
          {/*onChange={this.feildsChange.bind(this,'shipping_policy','free_shipping')}/>*/}
          {/*</div>*/}
          {this.state.shipping_policy.service_type !== 'FreightFlat' &&
          <div style={{marginTop: "3rem"}}>
            <Checkbox
              checked={this.state.shipping_policy.global_shipping}
              label="Global Shipping"
              onChange={this.feildsChange.bind(this, 'shipping_policy', 'global_shipping')}/>
          </div>
          }
        </Stack>
        {/*<Stack vertical={true} fill>*/}
        {/*  <Select*/}
        {/*    key={'selectShippingpackageType'}*/}
        {/*    options={shippingPackageType}*/}
        {/*    label={'Package Type'}*/}
        {/*    placeholder={'Select...'}*/}
        {/*    value={this.state.shipping_policy.shipping_package_type}*/}
        {/*    onChange={this.feildsChange.bind(this,'shipping_policy','shipping_package_type')}/>*/}
        {/*</Stack>*/}
        {this.state.shipping_policy.service_type !== 'FreightFlat' &&
        <Card title={"Domestic Shipping Services"} actions={[{
          content: 'Add services',
          onAction: this.Addserives.bind(this, 'domestic'),
          disabled: this.state.shipping_policy.shipping_service_domestic.length > 3
        }]}>
          {this.state.errors.business_policies.shipping_policy.domestic.service_not_selected &&
          <Card.Section>
            <Banner status={"critical"}>
              <p><b>Shipping Services</b> is a required field,Kindly select a value for {this.state.errors.business_policies.shipping_policy.domestic.null_services.join(',')} services below.</p>
            </Banner>
          </Card.Section>
          }
          <Card.Section>
            {
              this.getShippingPolicydomestic()
            }
          </Card.Section>
          <Card.Section>
            <FormLayout>
              <FormLayout.Group condensed>
                {/*<TextField*/}
                {/*label="Additional Charges"*/}
                {/*key={'DomesticAdditionalCharges'}*/}
                {/*prefix={"$"}*/}
                {/*value={this.state.shipping_policy.domestic.additional_charges}*/}
                {/*onChange={this.handleshippingPOlicyLevelTwo.bind(this,'domestic','additional_charges')}*/}
                {/*/>*/}
                <Select
                  key={'selectdomesticHandlingTime'}
                  options={this.state.options_recieved.handling_time}
                  error={this.state.errors.business_policies.shipping_policy.domestic.handling_time?'*required field':''}
                  label={'Handling Time'}
                  value={this.state.shipping_policy.domestic.handling_time}
                  onChange={this.handleshippingPOlicyLevelTwo.bind(this, 'domestic', 'handling_time')}/>
                {this.state.shipping_policy.service_type !== 'Flat' && this.state.shipping_policy.service_type !== 'FlatDomesticCalculatedInternational' &&
                <TextField
                  label="Handling Cost"
                  key={'DomesticHandCharges'}
                  prefix={"$"}
                  value={this.state.shipping_policy.domestic.handling_cost}
                  onChange={this.handleshippingPOlicyLevelTwo.bind(this, 'domestic', 'handling_cost')}
                />
                }
                <div style={{marginTop:'3rem'}}>
                  <Checkbox
                    checked={this.state.shipping_policy.domestic.PromotionalShippingDiscount}
                    label="Promotional shipping discount"
                    onChange={this.handleshippingPOlicyLevelTwo.bind(this, 'domestic', 'PromotionalShippingDiscount')}/>
                </div>
              </FormLayout.Group>


            </FormLayout>
          </Card.Section>
          { this.state.site_id ==='MOTORS' &&
          <Card.Section>
            <FormLayout>
              <FormLayout.Group condensed>
                <Select
                  key={'BuyerResponsibleForpickup'}
                  options={[{label: 'Yes', value: 'yes'}, {label: 'No', value: 'no'}]}
                  label={'Buyer responsible for pickup'}
                  placeholder={'Please select ...'}
                  value={this.state.shipping_policy.domestic.buyer_responsible_for_pickup}
                  error={this.state.errors.business_policies.shipping_policy.domestic.buyer_responsible_for_pickup ? '*required field' : ''}
                  onChange={this.handleshippingPOlicyLevelTwo.bind(this, 'domestic', 'buyer_responsible_for_pickup')}/>
                <div style={{marginTop:'3rem'}}>
                  <Checkbox
                    checked={this.state.shipping_policy.domestic.buyer_responsible_for_shipping}
                    label="Buyer responsible for shipping"
                    onChange={this.handleshippingPOlicyLevelTwo.bind(this, 'domestic', 'buyer_responsible_for_shipping')}/>
                </div>
                <TextField
                  label="Shipping surcharge"
                  key={'ShippingSurcharge'}
                  type={"number"}
                  value={this.state.shipping_policy.domestic.shipping_surcharge}
                  onChange={this.handleshippingPOlicyLevelTwo.bind(this, 'domestic', 'shipping_surcharge')}
                />
              </FormLayout.Group>
            </FormLayout>
          </Card.Section>
          }
        </Card>
        }
        {this.state.shipping_policy.service_type !== 'FreightFlat' &&
        <Card title={"International Shipping Services"}
              actions={[{content: 'Add services', onAction: this.Addserives.bind(this, 'international'),disabled:this.state.shipping_policy.shipping_service_international.length>4}]}>
          {
            this.state.errors.business_policies.shipping_policy.international.service_not_selected &&
          <Card.Section>
            <Banner status={"critical"}>
              <p><b>Shipping Services</b> is a required field,Kindly select a value for {this.state.errors.business_policies.shipping_policy.international.null_services.join(',')} services below</p>
            </Banner>
          </Card.Section>
          }
          <Card.Section>
            {
              this.getShippingPolicyInternational()
            }
          </Card.Section>
          <Card.Section>
            <FormLayout>
              {this.state.shipping_policy.service_type !== 'Flat' && this.state.shipping_policy.service_type !== 'CalculatedDomesticFlatInternational' &&

              <TextField
                label="Handling Cost"
                key={'DomesticHandCharges'}
                prefix={"$"}
                value={this.state.shipping_policy.international.handling_cost}
                onChange={this.handleshippingPOlicyLevelTwo.bind(this, 'international', 'handling_cost')}
              />
              }
              <div style={{marginTop:'3rem'}}>
                <Checkbox
                  checked={this.state.shipping_policy.international.InternationalPromotionalShippingDiscount}
                  label="Promotional shipping discount"
                  onChange={this.handleshippingPOlicyLevelTwo.bind(this, 'international', 'InternationalPromotionalShippingDiscount')}/>
              </div>
              <div style={{maxHeight:70,overflowY:'scroll'}}>
                <ChoiceList
                  key={'ShiptoDestinationalAreasInternational'}
                  title={'Choose global shipping destinations'}
                  allowMultiple
                  choices={countriestoInclude}
                  selected={this.state.shipping_policy.international.global_ship_to}
                  onChange={this.handleshippingPOlicyLevelTwo.bind(this, 'international','global_ship_to')}
                />
              </div>
            </FormLayout>
          </Card.Section>
          { this.state.site_id ==='MOTORS' &&
          <Card.Section>
            <FormLayout>
              <FormLayout.Group condensed>
                <Select
                  key={'BuyerResponsibleForpickup'}
                  options={[{label: 'Yes', value: 'yes'}, {label: 'No', value: 'no'}]}
                  label={'Buyer responsible for pickup'}
                  placeholder={'Please select ...'}
                  value={this.state.shipping_policy.international.buyer_responsible_for_pickup}
                  error={this.state.errors.business_policies.shipping_policy.international.buyer_responsible_for_pickup ? '*required field' : ''}
                  onChange={this.handleshippingPOlicyLevelTwo.bind(this, 'international', 'buyer_responsible_for_pickup')}/>
                <TextField
                  label="Shipping surcharge"
                  key={'ShippingSurcharge'}
                  type={"number"}
                  value={this.state.shipping_policy.international.shipping_surcharge}
                  onChange={this.handleshippingPOlicyLevelTwo.bind(this, 'international', 'shipping_surcharge')}
                />
                <div style={{marginTop:'3rem'}}>
                  <Checkbox
                    checked={this.state.shipping_policy.international.buyer_responsible_for_shipping}
                    label="Buyer responsible for shipping"
                    onChange={this.handleshippingPOlicyLevelTwo.bind(this, 'international', 'buyer_responsible_for_shipping')}/>
                </div>
              </FormLayout.Group>
            </FormLayout>
          </Card.Section>
          }
        </Card>
        }
      </Stack>
    );

    return temparr;

  }

  getShippingPolicydomestic(){
    let temparr=[];
    this.state.shipping_policy.shipping_service_domestic.forEach((service,index)=>{
      temparr.push(
        <Card title={"#"+(index+1)}  key={'ShippingDomesticCard'+index} actions={[{content:'Delete service',onAction:this.deleteService.bind(this,'domestic',index),disabled:this.state.shipping_policy.shipping_service_domestic.length===1}]}>
          <Card.Section>
            <FormLayout>
              <FormLayout.Group condensed>
                <Select
                  key={'ServiceTypeShipping'+index}
                  options={this.state.options_recieved.shipping_service_options.domestic}
                  label={'Shipping Services'}
                  placeholder={'Select Services...'}
                  value={this.state.shipping_policy.shipping_service_domestic[index].service}
                  onChange={this.handleShippingPolicyService.bind(this,'shipping_service_domestic',index,'service')}/>
                {this.state.shipping_policy.service_type !=='Calculated' && this.state.shipping_policy.service_type !=='CalculatedDomesticFlatInternational' &&
                <TextField
                  label="Charges"
                  key={'DomesticCharges' + index}
                  value={this.state.shipping_policy.shipping_service_domestic[index].charges}
                  disabled={this.state.shipping_policy.shipping_service_domestic[index].free_shipping}
                  onChange={this.handleShippingPolicyService.bind(this, 'shipping_service_domestic', index, 'charges')}
                />
                }
                {this.state.shipping_policy.service_type !=='Calculated' && this.state.shipping_policy.service_type !=='CalculatedDomesticFlatInternational' &&
                <TextField
                  label="Additional charges"
                  key={'Additionalcharges' + index}
                  value={this.state.shipping_policy.shipping_service_domestic[index].additional_charges}
                  disabled={this.state.shipping_policy.shipping_service_domestic[index].free_shipping}
                  onChange={this.handleShippingPolicyService.bind(this, 'shipping_service_domestic', index, 'additional_charges')}
                />
                }
                <TextField
                  label="COD fee"
                  key={'Codfee' + index}
                  value={this.state.shipping_policy.shipping_service_domestic[index].codfee}
                  onChange={this.handleShippingPolicyService.bind(this, 'shipping_service_domestic', index, 'codfee')}
                />
                <div style={{marginTop:'3rem'}}>
                  <Checkbox
                    key={"Free shipping"+index}
                    disabled={this.state.options_recieved.selected_domestic_service !== 'null' && index.toString() !== this.state.options_recieved.selected_domestic_service}
                    checked={this.state.shipping_policy.shipping_service_domestic[index].free_shipping}
                    label={"Free shipping"}
                    onChange={this.handleShippingPolicyService.bind(this, 'shipping_service_domestic', index, 'free_shipping')}
                  />
                </div>
              </FormLayout.Group>
            </FormLayout>
          </Card.Section>
        </Card>
      );
    });
    return temparr;
  }

  getShippingPolicyInternational(){
    let temparr=[];
    this.state.shipping_policy.shipping_service_international.forEach((service,index)=>{
      temparr.push(
        <Card title={"#"+(index+1)}  key={"ShippingPolicyinternationalCard"+index} actions={[{content:'Delete service',onAction:this.deleteService.bind(this,'international',index),disabled: this.state.shipping_policy.shipping_service_international.length===1}]}>
          <Card.Section>
            <FormLayout>
              <FormLayout.Group condensed>
                <div style={{maxWidth:'26rem'}}>
                  <Select
                    key={'ServiceTypeShipping'+index}
                    options={this.state.options_recieved.shipping_service_options.international}
                    label={'Shipping Services'}
                    placeholder={'Select Services...'}
                    value={this.state.shipping_policy.shipping_service_international[index].service}
                    onChange={this.handleShippingPolicyService.bind(this,'shipping_service_international',index,'service')}/>
                </div>
                {this.state.shipping_policy.service_type !=='Calculated' && this.state.shipping_policy.service_type !=='FlatDomesticCalculatedInternational' &&

                <TextField
                  label="Charges"
                  key={'InternationalCharges' + index}
                  value={this.state.shipping_policy.shipping_service_international[index].charges}
                  onChange={this.handleShippingPolicyService.bind(this, 'shipping_service_international', index, 'charges')}
                />

                }
                {this.state.shipping_policy.service_type !=='Calculated' && this.state.shipping_policy.service_type !=='FlatDomesticCalculatedInternational' &&

                <TextField
                  label="Additional charges"
                  key={'Additionalcharges' + index}
                  value={this.state.shipping_policy.shipping_service_international[index].additional_charges}
                  onChange={this.handleShippingPolicyService.bind(this, 'shipping_service_international', index, 'additional_charges')}
                />
                }
                <TextField
                  label="COD fee"
                  key={'codfeeInternational' + index}
                  value={this.state.shipping_policy.shipping_service_international[index].codfee}
                  onChange={this.handleShippingPolicyService.bind(this, 'shipping_service_international', index, 'codfee')}
                />
                {/*<div style={{marginTop:'3rem'}}>*/}
                {/*<Checkbox*/}
                {/*key={"Free shipping"+index}*/}
                {/*checked={this.state.shipping_policy.shipping_service_international[index].free_shipping}*/}
                {/*label={"Free shipping"}*/}
                {/*onChange={this.handleShippingPolicyService.bind(this, 'shipping_service_international', index, 'free_shipping')}*/}
                {/*/>*/}
                {/*</div>*/}
                {/*{this.state.shipping_policy.service_type !== 'Calculated' && this.state.shipping_policy.service_type !== 'FlatDomesticCalculatedInternational' &&*/}

                {/*<Select*/}
                {/*key={'Ship to'}*/}
                {/*options={InternationalShippingtoChoice}*/}
                {/*label={'Ship to'}*/}
                {/*value={this.state.shipping_policy.shipping_service_international[index].ship_to}*/}
                {/*onChange={this.handleShippingPolicyService.bind(this, 'shipping_service_international', index, 'ship_to')}/>*/}
                {/*}*/}

                {/*{*/}
                {/*this.state.shipping_policy.shipping_service_international[index].ship_to === 'custom' &&*/}
                <div style={{maxHeight:70,overflowY:'scroll'}}>
                  <ChoiceList
                    key={'DestinationalAreasInternational' + index}
                    title={'Choose Destination'}
                    allowMultiple
                    choices={countriestoInclude}
                    selected={this.state.shipping_policy.shipping_service_international[index].ship_to}
                    onChange={this.handleShippingPolicyService.bind(this, 'shipping_service_international', index, 'ship_to')}
                  />
                </div>
                {/*}*/}
              </FormLayout.Group>
            </FormLayout>
          </Card.Section>
        </Card>
      );
    });
    return temparr;
  }

  renderPaymentOption(){
    let temparr=[];
    temparr.push(
      <Stack vertical={true} distribution={"fillEvenly"} key={'paymentLayout'}>
        <TextField
          label="Payment Profile Name"
          key={'Payment Profile Name'}
          type="text"
          error={this.state.errors.business_policies.payment_policy.name?' ':''}
          helpText={'*required'}
          value={this.state.payment_policy.name}
          onChange={this.nameFeildChange.bind(this,'payment_policy','name')}
        />
        <Checkbox
          key={'chooseImmediatePay'}
          checked={this.state.payment_policy.immediate_pay}
          label="Immediate Pay"
          onChange={this.feildsChange.bind(this,'payment_policy','immediate_pay')}
        />
        {this.state.site_id === 'MOTORS' && this.state.errors.business_policies.payment_policy.motors.paypal &&
        <Banner status={"critical"}>
          <p>Paypal is a required payment method for your site</p>
        </Banner>
        }
        <ChoiceList
          key={'paymentOption'}
          title={'Payment Options'}
          allowMultiple
          error={this.state.errors.business_policies.payment_policy.selected?'*atleast one payment method is required':''}
          choices={this.state.payment_policy.immediate_pay?[{label:'PayPal',value:'PayPal'}]:this.state.options_recieved.payment_methods}
          selected={this.state.payment_policy.payment_methods}
          onChange={this.feildsChange.bind(this,'payment_policy','payment_methods')}
        />
        {this.state.payment_policy.payment_methods.indexOf('PayPal')>-1 &&
        <TextField
          label="Paypal email"
          key={'Paypal Email'}
          type="email"
          error={this.state.errors.business_policies.payment_policy.paypal_email?' ':''}
          helpText={'*required'}
          value={this.state.payment_policy.paypal_email}
          onChange={this.feildsChange.bind(this,'payment_policy','paypal_email')}
        />
        }
        <TextField
          label="Additional checkout instruction"
          key={'Additional checkout instruction'}
          value={this.state.payment_policy.checkout_instruction}
          onChange={this.feildsChange.bind(this,'payment_policy','checkout_instruction')}
          helpText={"This free-form string field allows the seller to give payment instructions to the buyer. These instructions will appear on eBay's view item and checkout pages."}
          multiline={3}
        />
      </Stack>
    );
    return temparr;

  }

  renderReturnPolicy(){
    let temparr=[];
    temparr.push(
      <FormLayout key={'returnPolicy'}>
        {/*<ChoiceList*/}
        {/*key={'returnPolicytypes'}*/}
        {/*title={'Return types'}*/}
        {/*allowMultiple*/}
        {/*choices={this.state.return_policy.return_accepted_options}*/}
        {/*selected={this.state.return_policy.return_accepted}*/}
        {/*onChange={this.feildsChange.bind(this,'return_policy','return_accepted')}*/}
        {/*/>*/}
        {/*<FormLayout.Group condensed>*/}
        {/*{this.state.return_policy.return_accepted.indexOf('domestic') > -1 &&*/}
        {/*<Card title={'Domestic returns settings'}>*/}
        {/*<Card.Section>*/}
        {/*<Stack vertical={true}>*/}
        <Select
          key={'DomesticcontactWithin'}
          options={!isUndefined(this.state.options_recieved.return_policy.ReturnsWithin)?this.state.options_recieved.return_policy.ReturnsWithin:[]}
          label={'After receiving the item, your buyer should contact you within:'}
          placeholder={'Select...'}
          error={this.state.errors.business_policies.return_policy.domestic.return_within?'*required field':''}
          value={this.state.return_policy.domestic.return_within}
          onChange={this.handleReturnPOlicyLevelTwo.bind(this,'domestic','return_within')}/>
        <Select
          key={'Returnpaidby'}
          options={!isUndefined(this.state.options_recieved.return_policy.ShippingCostPaidBy)?this.state.options_recieved.return_policy.ShippingCostPaidBy:[]}
          label={'Return shipping will be paid by:'}
          placeholder={'Select...'}
          error={this.state.errors.business_policies.return_policy.domestic.return_paid_by?'*required field':''}
          value={this.state.return_policy.domestic.return_paid_by}
          onChange={this.handleReturnPOlicyLevelTwo.bind(this,'domestic','return_paid_by')}/>
        {/*<Checkbox*/}
        {/*checked={this.state.return_policy.domestic.replacement_exchange_available}*/}
        {/*label="Replacement or exchange available"*/}
        {/*onChange={this.handleReturnPOlicyLevelTwo.bind(this,'domestic','replacement_exchange_available')}/>*/}
        {/*</Stack>*/}
        {/*</Card.Section>*/}
        {/*</Card>*/}
        {/*{this.state.return_policy.return_accepted.indexOf('international') > -1 &&*/}
        {/*<Card title={'International returns settings'}>*/}
        {/*<Card.Section>*/}
        {/*<Stack vertical={true}>*/}
        {/*<Select*/}
        {/*key={'InternationalcontactWithin'}*/}
        {/*options={!isUndefined(this.state.options_recieved.return_policy.ReturnsWithin)?this.state.options_recieved.return_policy.ReturnsWithin:[]}*/}
        {/*label={'After receiving the item, your buyer should contact you within:'}*/}
        {/*value={this.state.return_policy.international.return_within}*/}
        {/*onChange={this.handleReturnPOlicyLevelTwo.bind(this,'international','return_within')}/>*/}
        {/*<Select*/}
        {/*key={'Returnpaidby'}*/}
        {/*options={!isUndefined(this.state.options_recieved.return_policy.ShippingCostPaidBy)?this.state.options_recieved.return_policy.ShippingCostPaidBy:[]}*/}
        {/*label={'Return shipping will be paid by:'}*/}
        {/*value={this.state.return_policy.international.return_paid_by}*/}
        {/*onChange={this.handleReturnPOlicyLevelTwo.bind(this,'international','return_paid_by')}/>*/}
        {/*<Checkbox*/}
        {/*checked={this.state.return_policy.international.replacement_exchange_available}*/}
        {/*label="Replacement or exchange available"*/}
        {/*onChange={this.handleReturnPOlicyLevelTwo.bind(this,'international','replacement_exchange_available')}*/}
        {/*/>*/}
        {/*</Stack>*/}
        {/*</Card.Section>*/}
        {/*</Card>*/}
        {/*}*/}
        {/*</FormLayout.Group>*/}
      </FormLayout>
    );

    return temparr;
  }

  renderSellingdetails(){
    let temparr=[];
    temparr.push(
      <React.Fragment key={'selllingdetails'}>
        {/*<Card.Section title={'Selling Configurations'}>*/}
        {/*<Stack key={'salesConfigurations'} distribution={"fillEvenly"} vertical={false}>*/}
        {/*<Select*/}
        {/*key={'Format(Listing type)'}*/}
        {/*options={sellingFormatOptions}*/}
        {/*label={'Format(Listing type)'}*/}
        {/*value={this.state.selling_details.format}*/}
        {/*onChange={this.feildsChange.bind(this,'selling_details','format')}/>*/}
        {/*<Select*/}
        {/*key={'Listing Duration'}*/}
        {/*options={this.state.selling_details.format==='fixed_price'?sellingListingDurationFixed:sellingListingDurations}*/}
        {/*label={'Listing Duration'}*/}
        {/*disabled={this.state.selling_details.format==='fixed_price'}*/}
        {/*value={this.state.selling_details.listing_duration}*/}
        {/*onChange={this.feildsChange.bind(this,'selling_details','listing_duration')}/>*/}
        {/*</Stack>*/}
        {/*</Card.Section>*/}
        {false &&
        <Card.Section title={'Sales Tax details'}>
          <Stack key={'salestaxDetails'} distribution={"fillEvenly"} vertical={false}>
            <Select
              key={'CountrySalestax'}
              options={this.state.options_recieved.states}
              label={'State'}
              placeholder={'Please select...'}
              value={this.state.selling_details.state}
              onChange={this.feildsChange.bind(this, 'selling_details', 'state')}/>
            <TextField
              label="Tax Percentage"
              key={'Tax Percentage'}
              type={'number'}
              value={this.state.selling_details.tax_percentage}
              suffix="%"
              onChange={this.feildsChange.bind(this, 'selling_details', 'tax_percentage')}
            />
            <div style={{marginTop: "3rem"}}>
              <Checkbox
                key={'salestaxDetails'}
                checked={this.state.selling_details.shipping_include}
                label="Also apply to shipping and handling costs"
                onChange={this.feildsChange.bind(this, 'selling_details', 'shipping_include')}
              />
            </div>
          </Stack>
        </Card.Section>
        }
        <Card.Section title={'Item Location'}>
          <Stack key={'Item Location'} distribution={"fillEvenly"} vertical={false}>
            {/*{this.state.site_id === 'MOTORS' &&*/}
            {/*<Select*/}
            {/*key={'Currencylocation'}*/}
            {/*options={this.state.options_recieved.currency}*/}
            {/*label={'Currency'}*/}
            {/*placeholder={'Select...'}*/}
            {/*value={this.state.selling_details.item_location.currency}*/}
            {/*onChange={this.handlesellingDetailsLevelTwo.bind(this,'item_location','currency')}/>*/}
            <Select
              key={'Countrylocation'}
              options={this.state.options_recieved.country}
              label={'Country'}
              placeholder={'Select...'}
              value={this.state.selling_details.item_location.country}
              error={this.state.errors.config_data.item_location.country ? '*required' : ''}
              onChange={this.handlesellingDetailsLevelTwo.bind(this, 'item_location', 'country')}/>
            {/*}*/}
            <TextField
              label="Zip Code"
              key={'Zip Code'}
              error={this.state.errors.config_data.item_location.zipcode?'*required':''}
              value={this.state.selling_details.item_location.zipcode}
              onChange={this.handlesellingDetailsLevelTwo.bind(this,'item_location','zipcode')}
            />
            {/*<TextField*/}
            {/*label="City,State"*/}
            {/*key={'City,State'}*/}
            {/*error={this.state.errors.config_data.item_location.city_state?'*required field':''}*/}
            {/*value={this.state.selling_details.item_location.city_state}*/}
            {/*onChange={this.handlesellingDetailsLevelTwo.bind(this,'item_location','city_state')}*/}
            {/*/>*/}
          </Stack>
        </Card.Section>
        <Card.Section title={'App settings'}>
          <Stack vertical={false} distribution={"fillEvenly"} >
            {/*<Select*/}
            {/*key={'webhooksetting'}*/}
            {/*options={[{label:'Yes',value:'yes'},{label:'No',value:'no'}]}*/}
            {/*label={'Enable auto product syncing'}*/}
            {/*placeholder={"Choose.."}*/}
            {/*value={this.state.app_setting.product_sync}*/}
            {/*error={ this.state.errors.app_setting.product_sync?'*required':''}*/}
            {/*onChange={this.appSettingChange.bind(this, 'app_setting', 'product_sync')}/>*/}
            <Select
              key={'ordersync'}
              options={[{label:'Yes',value:'yes'},{label:'No',value:'no'}]}
              label={'Enable order syncing'}
              placeholder={"Choose.."}
              value={this.state.app_setting.order_sync}
              error={ this.state.errors.app_setting.order_sync?'*required':''}
              onChange={this.appSettingChange.bind(this, 'app_setting', 'order_sync')}/>
          </Stack>
        </Card.Section>
        {/*<Card.Section title={'Excluded Shipping Location'}>*/}
        {/*<Stack key={'Excluded Shipping Location'} distribution={"fillEvenly"} vertical={true}>*/}
        {/*<Checkbox*/}
        {/*key={'chooseExcluded Shipping Location'}*/}
        {/*checked={this.state.selling_details.exclude_locations}*/}
        {/*label="Create Exclusion List"*/}
        {/*onChange={this.feildsChange.bind(this,'selling_details','exclude_locations')}*/}
        {/*/>*/}
        {/*{this.state.selling_details.exclude_locations &&*/}
        {/*<div style={{maxHeight:100,overflowY:'scroll'}}>*/}
        {/*<ChoiceList*/}
        {/*key={'Exclusion Location'}*/}
        {/*title={'Exclude Location'}*/}
        {/*allowMultiple*/}
        {/*choices={ this.state.options_recieved.excluded_shipping_locations}*/}
        {/*selected={this.state.selling_details.excluded_shipping_location}*/}
        {/*onChange={this.feildsChange.bind(this, 'selling_details', 'excluded_shipping_location')}*/}
        {/*/>*/}
        {/*</div>*/}
        {/*}*/}
        {/*</Stack>*/}
        {/*</Card.Section>*/}
      </React.Fragment>

    );
    return temparr;
  }
  returnDescriptionReturn(){
    let temparr=[];
    let site_id=this.state.site_id;
    let countries=['DE','AT','FR','IT','ES'];
    if(countries.indexOf(site_id)>-1){
      temparr.push(
        <TextField
          label="Return description"
          key={'ReturnDescription'}
          type="text"
          multiline={5}
          value={this.state.return_policy.return_description}
          onChange={this.feildsChange.bind(this, 'return_policy', 'return_description')}
        />
      )

    }
    return temparr;
  }
//-----------------------------------Render Functions End------------------------------------//

//-----------------------------------Input Change Functions Change Start------------------------------------//

  enableForm(key){
    this.state.dropdown[key].show_dropdown=!this.state.dropdown[key].show_dropdown;
    this.setState(this.state);
  }
  dropdownChange(key,tag,value){
    let tempObj = Object.assign({}, this.state);
    tempObj.dropdown[key][tag] = value;
    this.setState(tempObj);
  }

  handleShippingPolicyService(key,index,tag,value){
    let tempObj=Object.assign({},this.state);
    tempObj['shipping_policy'][key][index][tag]=value;
    if(key==='shipping_service_domestic' && tag==='free_shipping' && value)
    {
      tempObj.options_recieved.selected_domestic_service=index.toString();
    }
    else{
      tempObj.options_recieved.selected_domestic_service='null';
    }
    this.setState(tempObj);

  }

  handleReturnPOlicyLevelTwo(key,tag,value){
    let tempObj=Object.assign({},this.state);
    tempObj['return_policy'][key][tag]=value;
    this.setState(tempObj);
  }

  handleshippingPOlicyLevelTwo(key,tag,value){
    let tempObj=Object.assign({},this.state);
    tempObj['shipping_policy'][key][tag]=value;

    this.setState(tempObj);
  }

  handlesellingDetailsLevelTwo(key,tag,value){
    let tempObj=Object.assign({},this.state);
    tempObj['selling_details'][key][tag]=value;
    this.setState(tempObj);
  }
  appSettingChange(key,tag,value){
    let tempObj = Object.assign({}, this.state);
    tempObj[key][tag] = value;
    this.setState(tempObj);
  }

  Addserives(type){


    switch(type){
      case 'domestic':
        let insertService=Object.assign({},tempObjShippingserviceDomestic);
        let currentServicedomestic=this.state.shipping_policy.shipping_service_domestic.slice(0);
        currentServicedomestic.push(insertService);
        this.state.shipping_policy.shipping_service_domestic=currentServicedomestic;
        this.setState(this.state);
        break;
      case 'international':
        let insertServiceinternational=Object.assign({},tempObjShippingserviceInternational);
        let currentServiceinternational=this.state.shipping_policy.shipping_service_international.slice(0);
        currentServiceinternational.push(insertServiceinternational);
        this.state.shipping_policy.shipping_service_international=currentServiceinternational;
        this.setState(this.state);
        break;
      default:console.log(type);

    }
  }
  deleteService(type,index){
    switch(type){
      case 'domestic':
        let currentServicedomestic=this.state.shipping_policy.shipping_service_domestic.slice(0);
        currentServicedomestic.splice(index,1);
        this.state.shipping_policy.shipping_service_domestic=currentServicedomestic;
        this.setState(this.state);
        break;
      case 'international':
        let currentServiceinternational=this.state.shipping_policy.shipping_service_international.slice(0);
        currentServiceinternational.splice(index,1);
        this.state.shipping_policy.shipping_service_international=currentServiceinternational;
        this.setState(this.state);
        break;
    }
  }

  nameFeildChange(key,tag,value) {
    let tempObj = Object.assign({}, this.state);
    tempObj[key][tag] = value;
    this.setState(tempObj);
    // this.nameErrorHandler(key);
  }


  feildsChangePaymentLevelTwo(key,tag,value){
    let tempObj=Object.assign({},this.state);
    tempObj.payment_policy[key][tag]=value;
    this.setState(tempObj);
  }

  feildsChange(key,tag,value){
    let tempObj=Object.assign({},this.state);
    tempObj[key][tag]=value;
    this.setState(tempObj);
    // this.FormErrorHandling(key);
    if(key==='payment_policy' && tag === 'immediate_pay'){
      this.state.payment_policy.payment_methods=[];
      this.state.payment_policy.payment_methods.push('PayPal');
      this.setState(this.state);
    }

    // if(key==='selling_details' && tag==='format' && value==='fixed_price'){
    //     this.state.selling_details.listing_duration='GTC';
    //     this.setState(this.state);
    // }
    // else if(key==='selling_details' && tag==='format' && value!=='fixed_price'){
    //     this.state.selling_details.listing_duration=3;
    //     this.setState(this.state);
    // }

    if(key==='shipping_policy' && tag==='service_type'){
      switch(value){
        case 'Flat' :
          this.state.options_recieved.shipping_service_options.domestic=this.state.options_recieved.shipping_service.domestic.Flat;
          this.state.options_recieved.shipping_service_options.international=this.state.options_recieved.shipping_service.international.Flat;
          break;
        case 'Calculated' :
          this.state.options_recieved.shipping_service_options.domestic=this.state.options_recieved.shipping_service.domestic.Calculated;
          this.state.options_recieved.shipping_service_options.international=this.state.options_recieved.shipping_service.international.Calculated;
          break;
        case 'FreightFlat' :
          this.state.options_recieved.shipping_service_options.domestic=this.state.options_recieved.shipping_service.domestic.FreightFlat;
          this.state.options_recieved.shipping_service_options.international=this.state.options_recieved.shipping_service.international.FreightFlat;
          break;
        case 'CalculatedDomesticFlatInternational' :
          this.state.options_recieved.shipping_service_options.domestic=this.state.options_recieved.shipping_service.domestic.Calculated;
          this.state.options_recieved.shipping_service_options.international=this.state.options_recieved.shipping_service.international.Flat;
          break;
        case 'FlatDomesticCalculatedInternational' :
          this.state.options_recieved.shipping_service_options.domestic=this.state.options_recieved.shipping_service.domestic.Flat;
          this.state.options_recieved.shipping_service_options.international=this.state.options_recieved.shipping_service.international.Calculated;
          break;
      }
      this.setState(this.state);
    }

  }

//-----------------------------------Input Change Functions Change End------------------------------------//
//-----------------------------------Save Function Start ------------------------------------//


  saveAllprofiles(){
    let tempObj = {
      shipping_policy: {},
      return_policy: {},
      payment_policy: {},
    };

    let tempObjTemp={
      business_policies:{},
      config_data:{},
      app_setting:{}
    }


    Object.keys(this.state.dropdown).map(key => {

      if (this.state.dropdown[key].show_dropdown) {
        tempObj[key]['existing_id'] = this.state.dropdown[key].selected_id;
      }
      else {

        tempObj[key]['profile_data'] = this.state[key];
      }
    });
    tempObjTemp.app_setting = Object.assign({},this.state.app_setting);
    tempObjTemp.config_data = this.state.selling_details;
    tempObjTemp.business_policies=Object.assign({},tempObj);
    if(this.verifyPresavedConfigs()) {
      let policy_validated = this.policyValidator(tempObjTemp.business_policies);
      let selling_details_validated=true;
      let appSettings=this.validateAppsettings(tempObjTemp.app_setting);
      if(!this.state.data_saved_successfully['config_data']) {
        selling_details_validated = this.sellingDetailsValidator(tempObjTemp.config_data);
      }else{
        delete tempObjTemp.config_data;
      }
      // removed condition of && appSettings
      if (policy_validated && selling_details_validated) {
        Object.keys(tempObjTemp.business_policies).map(key=>{
          if(this.state.data_saved_successfully[key]){
            delete tempObjTemp.business_policies[key]
          }
        });
        this.props.recieveFormData(tempObjTemp);
        this.isSetDisplay();
      }
      else {
        this.props.recieveFormData({errors: true});
      }
    }
    else{
      this.props.recieveFormData({allSaved: true});
    }


  }

//-----------------------------------Save Function End ------------------------------------//

//-----------------------------------Essential Function Start ------------------------------------//

  verifyPresavedConfigs(){
    let check=0;
    Object.keys(this.state.data_saved_successfully).map(key=>{
      if(this.state.data_saved_successfully[key]===false){
        check++;
      }
    })
    if(check>0){
      return true;
    }else{
      return false;
    }
  }
  redirect(url) {
    this.props.history.push(url);
  }

  isSetDisplay(){
    requests.getRequest('ebayV1/get/globalConfigData').then(data=>{
      if(data.success){
        // this.state.data_saved_successfully=data.data
        let tempObj={};
        if(!isUndefined(data.data)){

          Object.keys(data.data).map(key => {
            tempObj[key]=data.data[key]?true:false;
          });
          this.state.data_saved_successfully=Object.assign({},tempObj);
          this.setState(this.state);
        }
      }
    })
  }


  getShopdetails(){
    requests.getRequest('ebayV1/get/details',{site_id:'US'}).then(data => {
      if(data.success){
        this.extractCurrencyDetails(data.data[0]['CurrencyDetails']);
        this.extractReturnPolicyServices(data.data[0]['ReturnPolicyDetails']);
        this.extractCountryDetails(data.data[0]['CountryDetails']);
        this.extractExcludedLocations(data.data[0]['ExcludeShippingLocationDetails']);
        this.extractPaymentMethods(data.data[0]['PaymentMethods']);
        this.extractShippingDetails(data.data[0]['ShippingServiceDetails']);
        this.extractDispatchTimeMaxDetails(data.data[0]['DispatchTimeMaxDetails']);
        if(!isUndefined(data.data[0]['TaxJurisdiction'])) {
          this.extractStatefromsiteId(data.data[0]['TaxJurisdiction']);
        }
      }
    });
  }

  extractCurrencyDetails(data) {
    let temparr=[];
    Object.keys(data).map(key=>{
      temparr.push(
        {label:data[key]['Description'],value:data[key]['Currency']}
      );
    });
    this.state.options_recieved.currency=temparr;
    this.setState(this.state);
  }

  extractStatefromsiteId(data){
    let temparr=[];
    data.forEach((tax_detail,index)=>{
      temparr.push(
        {label:tax_detail['JurisdictionName'],value:tax_detail['JurisdictionID']}
      )
    });
    this.state.options_recieved.states=temparr;
    this.setState(this.state);
  }


  getBusinessPolicy(){
    requests.getRequest('ebayV1/template/get',{fullData:true}).then(data => {
      if(data.success){
        if(data.data.length!==0){
          this.createDropdownData(data.data);
        }else{
          this.state.dropdown.payment_policy.show_dropdown=false;
          this.state.dropdown.shipping_policy.show_dropdown=false;
          this.state.dropdown.return_policy.show_dropdown=false;
          this.setState(this.state);
        }
      }
      else{
        this.state.dropdown.payment_policy.show_dropdown=false;
        this.state.dropdown.shipping_policy.show_dropdown=false;
        this.state.dropdown.return_policy.show_dropdown=false;
        this.setState(this.state);
      }

    });
  }

  getSideID() {
    requests.getRequest('ebayV1/get/siteId').then(data => {
      if (data.success) {
        this.state.site_id = !isUndefined(data.data.site_id) ? data.data.site_id : '';

        // this.state.site_id ='MOTORS';
      }
    });
    this.setState(this.state);
  }

  createDropdownData(data){
    let return_dropdown_options=[];
    let payment_dropdown_options=[];
    let shipping_dropdown_options=[];

    data.forEach((obj,index)=>{
      switch (obj.type) {
        case 'return':
          if(!isUndefined(obj.data))
          {
            return_dropdown_options.push(
              {label:obj.data.profileName,value:(obj.data.profileId).toString()}
            );
          }
          break
        case 'payment':
          if(!isUndefined(obj.data))
          {
            payment_dropdown_options.push(
              {label:obj.data.profileName,value:(obj.data.profileId).toString()}
            );
          }
          break;
        case 'shipping':
          if(!isUndefined(obj.data))
          {
            shipping_dropdown_options.push(
              {label:obj.data.profileName,value:(obj.data.profileId).toString()}
            );
          }
          break;

      }
    });
    if(return_dropdown_options.length===0){
      this.state.dropdown.return_policy.show_dropdown=false;
    }
    else{
      this.state.dropdown.return_policy.show_dropdown=true;
      this.state.dropdown.return_policy.options=return_dropdown_options;
    }
    if(payment_dropdown_options.length===0){
      this.state.dropdown.payment_policy.show_dropdown=false;
    } else{
      this.state.dropdown.payment_policy.show_dropdown=true;
      this.state.dropdown.payment_policy.options=payment_dropdown_options;
    }
    if(shipping_dropdown_options.length===0){
      this.state.dropdown.shipping_policy.show_dropdown=false;
    }else{
      this.state.dropdown.shipping_policy.show_dropdown=true;
      this.state.dropdown.shipping_policy.options=shipping_dropdown_options;
    }
    this.setState(this.state);
  }

//-----------------------------------Essential Function End ------------------------------------//

}

export default AccountSettings;